// Localized labels for the 5 fixed roles.
//
// Per the design-handoff-strict rule + the locale-free RoleBadge component:
// the design-system never holds locale strings. Admin owns these labels.
// Source: design/UI : UX v1.0/for-engineering-users/specs/users-strings.md
// role table.

import type { RoleKey } from '@gc-coach/shared';

type T = (key: string) => string;

const LABEL_KEYS: Record<RoleKey, string> = {
  super_admin: 'roles.super_admin',
  content_editor: 'roles.content_editor',
  customer_success: 'roles.customer_success',
  analyst: 'roles.analyst',
  read_only: 'roles.read_only',
};

/** Resolve the localized label for a role via the i18n `t()` helper. */
export function roleLabel(role: RoleKey, t: T): string {
  return t(LABEL_KEYS[role]);
}
